export default "__VITE_ASSET__05f8a2c3__"